import { initializeApp } from "firebase/app"
import { getAuth, GoogleAuthProvider } from "firebase/auth"
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyArIyHVFEONfDGwUy5AqHKXUh1IOq8jZw0",
  authDomain: "grand-archive-search.firebaseapp.com",
  projectId: "grand-archive-search",
  storageBucket: "grand-archive-search.appspot.com",
  messagingSenderId: "128094084770",
  appId: "1:128094084770:web:fbb1232f49cd9f8967c1fb",
  measurementId: "G-TJNHNZ552R",
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
// IndexedDB-backed cache: queued writes are journaled locally, so an
// edit made moments before the tab closes (or while offline) survives
// and syncs on the next visit instead of dying with the page
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
})
export const googleProvider = new GoogleAuthProvider()
